import propTypes from 'prop-types';
import ModalComp from './Modal';
import Text from './Text';
import { useState } from 'react';
import { Stack } from '@mui/material';
import CustomButton from './Button';
import { removeShowDisclaimer } from 'reduxStore/authSlice';
import { useDispatch } from 'react-redux';

const Disclaimer = () => {
  const [addOpenModal, setAddOpenModal] = useState(true);
  const dispatch = useDispatch();

  const handleRemoveItem = () => {
    dispatch(removeShowDisclaimer());
  };

  return (
    <ModalComp
      max={500}
      header="Disclaimer"
      open={addOpenModal}
      setOpen={setAddOpenModal}
      onCancle={handleRemoveItem}>
      <Stack sx={{ margin: 1 }}>
        <Text align="justify">
          <p style={{ marginBottom: '1vh' }}>
            Using this calculator agrees to the below terms & Conditions.
          </p>
          Installer shall check existing job site conditions and dimensions prior to installation.
          Installer shall report any discrepancies or conflicts to TRA Snow and Sun prior to
          commencing work. Drawings and quotes are based upon information provided by the customer.
          <p style={{ marginTop: '1vh' }}>
            TRA Snow and Sun is not liable for any information that is found to be incorrect or
            false. Any snow bracket quantity shown is for estimating purposes only and is based on
            the calculated number of snow brackets per roofing square. Installer is responsible to
            verify proper snow bracket quantity based on actual number of roofing squares. All
            structures are to be checked for code compliance by the customer.
          </p>
        </Text>

        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mt: -3 }}>
          <CustomButton
            type="submit"
            sx={{ mb: -1, mt: 3 }}
            onClick={() => {
              handleRemoveItem();
              setAddOpenModal(false);
            }}>
            OK
          </CustomButton>
        </Stack>
      </Stack>
    </ModalComp>
  );
};
Disclaimer.propTypes = {
  addOpenModal: propTypes.bool,
  setAddOpenModal: propTypes.func,
  setSuccessMessage: propTypes.func,
  setErrorMessage: propTypes.func,
  setShowAlertBar: propTypes.bool
};
export default Disclaimer;
